var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "icon_qacom"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_qadetail" },
        React.createElement(
          "g",
          { id: "item_icon" },
          React.createElement(
            "g",
            { id: "icon_qacom" },
            React.createElement(
              "g",
              { id: "base_icon" },
              React.createElement("circle", { id: "fig_cercle", className: styles["cls-1"] || "cls-1", cx: "11", cy: "11", r: "11" })
            ),
            React.createElement(
              "g",
              { id: "icon_hospital" },
              React.createElement("path", { id: "item_build", className: styles["cls-2"] || "cls-2", d: "M6 4v13h10V4zm3 10H7v-2h2zm0-3H7V9h2zm0-3H7V6h2zm3 6h-2v-2h2zm0-3h-2V9h2zm0-3h-2V6h2zm3 6h-2v-2h2zm0-3h-2V9h2zm0-3h-2V6h2z" })
            )
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/iconStroke/images/qacom.svg
// module id = 1651
// module chunks = 0